module.exports = global["React"] = require("-!./react.js");


//////////////////
// WEBPACK FOOTER
// ./~/react/react.js
// module id = 463
// module chunks = 0